import * as React from "react"

function LogfileIcon({...props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.437 19.578"
      {...props}
    >
      <path
        data-name="Path 63"
        d="M14.73 18.477a.541.541 0 01-.54.54H2.247a.541.541 0 01-.54-.54V1.1a.541.541 0 01.54-.54h9.01v3.473h3.473z"
        fill="#fff"
      />
      <path
        data-name="Path 64"
        d="M11.257 0h-9.01a1.1 1.1 0 00-1.1 1.1v17.377a1.1 1.1 0 001.1 1.1H14.19a1.1 1.1 0 001.1-1.1V4.037zm3.473 18.477a.541.541 0 01-.54.54H2.247a.541.541 0 01-.54-.54V1.1a.541.541 0 01.54-.54h9.01v3.473h3.473z"
        fill="#2b669f"
      />
      <path data-name="Path 65" d="M11.257 0v4.037h4.033z" fill="#084272" />
      <g data-name="Group 33">
        <path
          data-name="Path 66"
          d="M16.437 17.416H0v-5.591a.692.692 0 01.693-.693H15.74a.692.692 0 01.693.693v5.591z"
          fill="#084272"
        />
        <path
          data-name="Path 67"
          d="M15.29 17.416v.764l1.147-.764zm-14.143 0v.764L0 17.416z"
          fill="#1a252d"
        />
        <path
          data-name="Path 68"
          d="M.705 11.841h15.024v4.875H.705z"
          fill="#f26522"
        />
      </g>
      <g data-name="Group 34">
        <path
          data-name="Path 69"
          d="M9.875 2.843h-6.93a.262.262 0 010-.525h6.93a.262.262 0 110 .525zm0 1.253h-6.93a.262.262 0 110-.525h6.93a.262.262 0 110 .525zm3.661 1.249H2.944a.262.262 0 010-.525h10.591a.262.262 0 110 .525zm0 1.253H2.944a.262.262 0 010-.525h10.591a.262.262 0 110 .525zm0 1.253H2.944a.262.262 0 110-.525h10.591a.262.262 0 110 .525zm0 1.249H2.944a.262.262 0 110-.525h10.591a.262.262 0 110 .525zm0 1.253H2.944a.262.262 0 010-.525h10.591a.262.262 0 110 .525z"
          fill="#2b669f"
        />
      </g>
      <g data-name="Group 35">
        <path
          data-name="Path 70"
          d="M6.445 15.157h-.533V12.71h.533zm.478-.865a.893.893 0 01.215-.623.768.768 0 01.6-.239.776.776 0 01.607.239.893.893 0 01.215.623v.031a.886.886 0 01-.215.623.885.885 0 01-1.21 0 .893.893 0 01-.215-.623zm.529.035a.734.734 0 00.067.337.27.27 0 00.45 0 .717.717 0 00.067-.333v-.039a.739.739 0 00-.067-.333.238.238 0 00-.227-.125.232.232 0 00-.223.125.728.728 0 00-.067.333zm1.5-.016a1.081 1.081 0 01.172-.638.571.571 0 01.489-.243.422.422 0 01.235.063.6.6 0 01.176.18l.035-.211h.466v1.68a.636.636 0 01-.231.521.994.994 0 01-.634.184 1.2 1.2 0 01-.278-.035 1.38 1.38 0 01-.278-.1l.09-.392a1.037 1.037 0 00.219.074 1.1 1.1 0 00.239.023.4.4 0 00.251-.067.258.258 0 00.082-.211v-.129a.478.478 0 01-.168.141.483.483 0 01-.215.047.574.574 0 01-.486-.231 1.013 1.013 0 01-.172-.615v-.042zm.529.031a.712.712 0 00.059.321.208.208 0 00.2.114.348.348 0 00.149-.027.254.254 0 00.1-.078v-.713a.294.294 0 00-.1-.094.33.33 0 00-.145-.031.213.213 0 00-.2.129.786.786 0 00-.063.345z"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

export default LogfileIcon